import {Component, EventEmitter, Output, Input, ViewEncapsulation} from '@angular/core';
import {MobileCheckServiceService} from '../../../../services/mobile-check-service.service';
import {ModalService} from '../../../../services/modal.service';
import {AlertType} from '../../../../enums/alert-type';

@Component({
  selector: 'app-toggle-list-button',
  templateUrl: './toggle-list-button.component.html',
  styleUrls: ['./toggle-list-button.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ToggleListButtonComponent {
  @Input() isGridSelected = true;
  @Output() onListToggle = new EventEmitter<void>();
  @Output() onGridToggle = new EventEmitter<void>();

  constructor(private mobileService: MobileCheckServiceService,
              private modalService: ModalService) {
  }

  showListView(): void {
    if (this.mobileService.mobileDevice) {
      this.showMobileMessageDialog();
      return;
    }
    this.onListToggle.emit();
  }
  showGridView(): void {
    this.onGridToggle.emit();
  }


  private showMobileMessageDialog(): void {
    this.modalService.showAlert({
      type: AlertType.Prompt,
      class: 'modal-prompt',
      headerClass: '',
      headerIcon: '',
      title: 'usability recommendation',
      message: 'For the best mobile experience, please use the current view. Due to it\'s complexity, Product List View is not fully optimized for mobile devices.',
      actionLabel: 'Dismiss',
      actionClass: 'btn-primary'
    });

  }
}
